import { useEffect, useState } from 'react';

import { useAddInstFacebookPages } from '../../api';

import { AddButton } from '@/components';
import { Departments } from '@/types';

const SCOPE = [
  'instagram_basic',
  'instagram_manage_messages',
  'pages_manage_metadata',
  'pages_show_list',
  'business_management',
  'pages_read_engagement',
  'instagram_manage_comments',
  'pages_messaging',
].join(',');

type FBAuthResponse = {
  accessToken: string;
  userID: string;
};

type FBLoginResponse = {
  authResponse: FBAuthResponse | null;
  status?: string;
};

declare global {
  interface Window {
    FB?: {
      login: (cb: (res: FBLoginResponse) => void, options: { scope: string }) => void;
      init: (params: Record<string, unknown>) => void;
    };
    fbReadyPromise?: Promise<void>;
  }
}

type Props = {
  isLoading: boolean;
  department: Departments;
};

export const AddInstFacebookPagesButton = ({ isLoading, department }: Props) => {
  const addInstPages = useAddInstFacebookPages();
  const [isFbReady, setIsFbReady] = useState(false);

  useEffect(() => {
    const ready = window.fbReadyPromise;
    if (!ready) return;
    let cancelled = false;
    ready.then(() => {
      if (!cancelled) setIsFbReady(true);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  const handleClick = () => {
    if (!isFbReady || !window.FB) return;
    window.FB.login(
      (res) => {
        if (res.authResponse) {
          addInstPages.mutate({ token: res.authResponse.accessToken, department });
        }
      },
      { scope: SCOPE }
    );
  };

  return (
    <AddButton
      isLoading={isLoading || addInstPages.isLoading || !isFbReady}
      onClick={handleClick}
      text="FACEBOOK CONNECT"
    />
  );
};
